<script setup>
import { ref, onMounted, onUnmounted, reactive } from 'vue'
import footerLogo from '@/assets/images/icon/logo.png';
import backgroundImageUrl from '@/assets/images/footer1.png'
import ToTop from './toTop.vue'
const menuItems = ref([
  { title: '首页', path: '/' },
  { title: '功能', path: '/products' },
  { title: '价格', path: '/pricing' },
  { title: '服务', path: '/solutions' },
  { title: '知道', path: '/about' }
]);

const linkList = ref([
  { id: 1, title: "跨境电商ERP软件", link: ' http://www.douples.com/hy/info.aspx?itemid=14'},
  { id: 2, title: "亚马逊VC订单系统", link: 'https://www.aidoully.com/products'},
  { id: 3, title: "跨境电商VC ERP系统 ", link: 'https://www.aidoully.com/pricing'},
  { id: 4, title: "VC ERP系统开发", link: 'http://www.douples.com/nl/info.aspx?itemid=1139&lcid=3'},
  { id: 5, title: "Amazon VC服务", link: ' https://www.aidoully.com'},
])

const isTop = ref(false)

const scrollTop = ref(0)


const handleScroll = () => {
  // 获取滚动位置
  const scrollPosition = window.scrollY || document.documentElement.scrollTop

  scrollTop.value = scrollTop.value || scrollPosition
  if (scrollPosition > 900) {
    isTop.value = scrollPosition > scrollTop.value
    scrollTop.value = scrollPosition
  }

}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  // 初始化检查一次
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <div class="footer">
    <div class="footer-container">
      <div class="footer-bg-image" v-lazy:background-image="backgroundImageUrl"></div>
      <div class="footer-logo-container">
        <!-- <img class="footer-logo" :src="footerLogo" alt=""/> -->
        <p class="footer-title">帮助出海企业管好货和钱</p>
      </div>
      <div class="nav-menu">
        <div v-for="(item, index) in menuItems" :key="item.path" class="nav-item">
          <router-link :to="item.path" class="nav-link" active-class="active">
            {{ item.title }}
          </router-link>
          <span v-if="index < menuItems.length - 1" class="separator">|</span>
        </div>
      </div>
      <div class="footer-link">
        友情链接：<span class="footer-span" v-for="item in linkList" :key="item.id">
          <a :href="item.link" target="_blank" rel="noopener noreferrer" class="footer-link-item">{{ item.title }}</a>
        </span>
      </div>
      <p class="recordNumber">Copyright ◎ 2025 深圳达普信科技有限公司. Al Rights Reserved.<a href="https://beian.miit.gov.cn" class="record-number">粤ICP备15113791号-6</a></p>
    </div>
    <!-- <div is="basis-to-top-button" class="button-container button-container--show-mobile button-container--show-desktop"
      :class="isTop ? '' : 'button-container--hidden'" style="right: 5%;">
      <button class="button toTopButton is-hoverable" @click="scrollToTop">
        <span class="button--primary-text">
          顶部
        </span>
      </button>
    </div> -->
    <ToTop></ToTop>
  </div>
</template>

<style scoped>
.footer {
  width: 100%;
  padding-top: 33px;
  padding-bottom: 25px;
  position: relative; /* 确保背景图片能正确定位 */
  background-color: #030303;
}

.footer-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  margin-bottom: 30px;
  padding: 0 20px;
  text-align: center;
}

.footer-title{
  font-family: 'DingTalk-JinBuTi';
  font-weight: normal;
  font-size: 28px;
  color: #fff;
  line-height: 1.2;
  text-align: center;
  font-style: normal;
  margin-bottom: 0;
}

.footer-container {
  width: 100%;
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.footer-bg-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px; /* 减小背景图片尺寸 */
  height: 144px; /* 减小背景图片尺寸 */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.8; /* 调整透明度，让文字可读 */
  z-index: 0; /* 确保在文字下面 */
}

.footer-container {
  position: relative; /* 确保内容在背景之上 */
  z-index: 1; /* 确保内容在背景之上 */
  /* 其他样式保持不变 */
}

.footer-logo {
  width: 120px;
  object-fit: contain;
  height: 40px;
}

.footer-text {
  font-style: italic;
  opacity: 0.8;
}

.recordNumber {
  font-size: 12px;
  height: auto;
  line-height: 1.5;
  margin-bottom: 0;
  color: #FFFFFF;
  text-align: center;
  padding: 0 20px;
}

.nav-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: auto;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 14px;
  z-index: 10;
  padding: 0 20px;
}

.nav-item {
  display: flex;
  align-items: center;
  margin: 5px 0;
}

.nav-link {
  /* padding: 8px 10px; */
  text-decoration: none;
  color: #fff;
  transition: color 0.3s;
  z-index: 11;
  white-space: nowrap;
}

.nav-link:hover {
  color: #F4333C;
}

.nav-link.active {
  color: #F4333C;
  font-weight: bold;
}

.separator {
  color: #ddd;
  padding: 0 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer {
    height: auto;
    min-height: 240px;
    padding-top: 25px;
    padding-bottom: 20px;
  }
  
  .footer-title {
    font-size: 22px;
  }
  
  .footer-bg-image {
    width: 200px;
    height: 103px;
  }
  
  .nav-menu {
    font-size: 12px;
    margin-bottom: 20px;
  }
  
  .nav-link {
    padding: 6px 8px;
  }
  
  .recordNumber {
    font-size: 10px;
    line-height: 1.4;
  }
}

@media (max-width: 480px) {
  .footer {
    padding-top: 20px;
    padding-bottom: 15px;
  }
  
  .footer-title {
    font-size: 18px;
  }
  
  .footer-bg-image {
    width: 150px;
    height: 77px;
  }
  
  .nav-menu {
    font-size: 11px;
    margin-bottom: 15px;
  }
  
  .nav-link {
    padding: 4px 6px;
  }
  
  .recordNumber {
    font-size: 9px;
  }
  
  .footer-logo-container {
    margin-bottom: 20px;
  }
}
.record-number{
  color: #fff;
  cursor: pointer;
}
.record-number :hover{
  color: #FE4554 !important;
}
.footer-link {
  font-weight: 500;
  font-size: 14px;
  color: #fff;
  margin-bottom: 24px;
}
.footer-span {
  margin-left: 10px;
}
.footer-span a{
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #fff !important;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  opacity: .5;
  text-decoration: none;
  transition: opacity 0.2s ease;
}
.footer-span a:hover {
  color: #fff !important;
  opacity: 1;
  text-decoration: none;
  cursor: pointer;
}
</style>